import React from 'react';
import { Icons } from 'Assets';

interface Props {
  ruleText: string;
  input?: string;
  regex: RegExp;
  tooltip?: boolean;
}

export const RuleCheck: React.FC<Props> = ({ ruleText, input, regex, tooltip }) => (
  <div className="flex flex-row h-[22px]">
    <div className="flex gap-2 items-center">
      {input && regex.test(input) ? (
        <>
          <img className="h-4 w-4" src={Icons.GreenCheck} alt="ok" />
          <div className="text-spanish-gray">{ruleText}</div>
        </>
      ) : (
        <>
          <div className="flex rounded-full bg-light-silver h-4 w-4" />
          <div>{ruleText}</div>
        </>
      )}
      <div className="relative">
        {tooltip && <img src={Icons.QuestionMarkGrey} alt="exemple" className="peer h-4 w-4" />}
        <div
          className={
            'invisible peer-hover:visible absolute -right-4 h-[68px] w-[270px] text-[14px] -mt-24 -mx-3 bg-white p-3 shadow-xl' +
            " before:h-2.5 before:w-2.5 before:rotate-45 before:absolute before:right-[31px] before:bottom-[-5px] before:content-['']" +
            ' before:bg-white'
          }
        >
          {'Exemple\u00A0:\u00A0!"#$%\u0026\'()*+,-./:;\u003C=\u003E?@[]^_`{|}~'}
        </div>
      </div>
    </div>
  </div>
);
